import React from 'react'

const AllReviews = () => {
  return (
    <div>AllReviews</div>
  )
}

export default AllReviews